import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-700.css'
import 'element-plus/dist/index.css'
import './assets/styles/element-plus.css'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css'
import permissionDirective from './directives/permission'
import modalA11yDirective from './directives/modalA11y'
import safeHtmlDirective from './directives/safeHtml'
import { formatDateTime } from '@/utils/dateFormat'
import installFlowUi from './plugins/guns.js'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(installFlowUi)
app.directive('permission', permissionDirective)
app.directive('modal-a11y', modalA11yDirective)
app.directive('safe-html', safeHtmlDirective)

// 注册全局时间格式化方法
app.config.globalProperties.$formatDateTime = formatDateTime

app.mount('#app')
